<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-header">
                        <div class="pull-left">
                            <h4 class="card-title float-left">{{name}}</h4>
                        </div>
                        <button class="all-btn add-btn pull-right" @click="addAnalog" v-if="comparison.analogs.length < 4 && comparison.wizardSection===1">Аналог қўшиш</button>
                        <div class="pull-right mr-5 mt-2" v-if="comparison.exchangeRate && comparison.exchangeRate > 0">
                            1 USD = {{comparison.exchangeRate | currency('', 2, { thousandsSeparator: ' ' })}} UZS ({{comparison.exchangeRateDate}})
                        </div>
                    </div>
                    <div class="card-body" v-if="comparison.wizardSection===1">
                        <div class="row">
                            <div class="col-12 table-responsive">
                                <div class="table-wrapper">
                                  <table class="table table-striped comparison-table" style="min-width: 900px">
                                      <tr>
                                          <th>Курсаткичлар</th>
                                          <th></th>
                                          <th class="text-center" v-for="(analog, index) in comparison.analogs" :key="index" style="position: relative">
                                              аналог {{index + 1}}
                                              <i class="fa fa-remove red"
                                                 style="position: absolute;right: 3px;top: 3px;cursor: pointer"
                                                 @click="removeAnalog(index)"></i>
                                          </th>
                                      </tr>
                                      <tr>
                                          <td>Маълумотлар манбаси</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index">
                                              <input type="text" class="form-control" v-model="analog.source" style="text-align: center"
                                                     :class="{invalid : $v.comparison.analogs.$each[index].source.$error}"/>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Манзили</td>
                                          <td>
                                              <div class="text-center" v-if="region && region.parent && region.parent.label">{{region.parent.label}}</div>
                                              <div class="text-center" v-if="region && region.label">{{region.label}}</div>
                                          </td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <treeselect class="form-control" v-model="analog.region" :multiple="false" placeholder="Танланг..." :options="ref.provinces"></treeselect>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Объект номи</td>
                                          <td>
                                          </td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              Бино ва иншоотлар
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Ижарага бериш майдони кв.м</td>
                                          <td class="text-center">
                                              <numeric-input v-model="comparison.area" :precision="2" align="center" :class="{invalid : $v.comparison.area.$error}"/>
                                          </td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <numeric-input v-model="analog.rentArea" :precision="2" align="center"
                                                             :class="{invalid : $v.comparison.analogs.$each[index].rentArea.$error}"/>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>1 ойлик ижара тулови (сум)</td>
                                          <td>
                                          </td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <numeric-input v-model="analog.rentPerMonth" :precision="2" align="center"
                                                             :class="{invalid : $v.comparison.analogs.$each[index].rentPerMonth.$error}"/>
                                          </td>
                                      </tr>

                                      <tr>
                                          <td>1 ойлик ижара тулови буйича таклифи (АКШ $) да 1м2 га</td>
                                          <td>
                                          </td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{analog.rentPerUnitUSD | currency('', 3, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>1 ойлик ижара тулови буйича таклифи сум 1м2 да</td>
                                          <td>
                                          </td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{analog.rentPerUnit | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Таклиф буйича 1 кв.мга 1 йиллик тулов</td>
                                          <td>
                                          </td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{analog.rentPerUnitYearly | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <!--<tr>-->
                                      <!--<td>Эълон санаси</td>-->
                                      <!--<td class="text-center">-->
                                      <!--жорий-->
                                      <!--<datepicker class="form-control" format="dd/MM/yyyy" v-model="comparison.advertisementDatePicked" :clear-button="true"></datepicker>-->
                                      <!--</td>-->
                                      <!--<td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">-->
                                      <!--<datepicker class="form-control" format="dd/MM/yyyy" v-model="analog.advertisementDatePicked" :clear-button="true"></datepicker>-->
                                      <!--</td>-->
                                      <!--</tr>-->
                                      <!--  <tr>
                                           <td>Марказга бориш имконияти</td>
                                           <td>
                                               <select class="form-control" v-model="comparison.closenessToCenter">
                                                   <option value="0">0 мин</option>
                                                   <option value="10">10 мин</option>
                                                   <option value="30">30 мин</option>
                                                   <option value="60">1 соат</option>
                                               </select>
                                           </td>
                                           <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                               <select class="form-control" v-model="analog.closenessToCenter">
                                                   <option value="0">0 мин</option>
                                                   <option value="10">10 мин</option>
                                                   <option value="30">30 мин</option>
                                                   <option value="60">1 соат</option>
                                               </select>
                                           </td>
                                       </tr> -->

                                      <tr class="section-start">
                                          <td :colspan="comparison.analogs.length + 2" class="text-center">
                                              Киритилган тузатишлар ва уларнинг мохияти
                                          </td>
                                      </tr>

                                      <tr class="section-start">
                                          <td>Эълон санаси</td>
                                          <td class="text-center">
                                              (жорий)
                                          </td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <datepicker class="form-control" format="dd/MM/yyyy"
                                                          v-model="analog.advertisementDatePicked"
                                                          :clear-button="true"
                                                          :disabledDates="model.disabledDates"
                                              ></datepicker>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td><i>Тузатишлар</i></td>
                                          <td class="text-center">%</td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <div class="percentage">
                                                  <numeric-input v-model="analog.fix.advertisementDatePicked" :precision="2" align="center" :allow-negative="true" readonly/>
                                                  <span>%</span>
                                              </div>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{analog.calculated.advertisementDatePicked | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>

                                      <!--TYPE OF LAW-->
                                      <!--   <tr>
                                             <td rowspan="2" class="font-weight-bold">
                                                 Топширилаётган хукук тури учун
                                             </td>
                                             <td class="text-center">Тузатиш фоизи</td>
                                             <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                 <numeric-input v-model="analog.fix.typeOfLaw" :precision="2" align="center" :allow-negative="true" class="percentage"/>
                                             </td>
                                         </tr>
                                         <tr>
                                             <td class="text-center">Тузатилган сумма</td>
                                             <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                 {{analog.calculated.typeOfLaw | currency('', 2, { thousandsSeparator: ' ' })}}
                                             </td>
                                         </tr> -->

                                      <!--FINANCIAL CONDITION-->
                                      <!--  <tr>
                                            <td rowspan="2" class="font-weight-bold">
                                                Молиялаштириш шарти учун
                                            </td>
                                            <td class="text-center">Тузатиш фоизи</td>
                                            <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                <numeric-input v-model="analog.fix.financialCondition" :precision="2" align="center" :allow-negative="true" class="percentage"/>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-center">Тузатилган сумма</td>
                                            <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                {{analog.calculated.financialCondition | currency('', 2, { thousandsSeparator: ' ' })}}
                                            </td>
                                        </tr> -->

                                      <!--TERMS OF SALES-->
                                      <!-- <tr>
                                           <td rowspan="2" class="font-weight-bold">
                                               Сотув шартлари учун
                                           </td>
                                           <td class="text-center">Тузатиш фоизи</td>
                                           <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                               <numeric-input v-model="analog.fix.termsOfSales" :precision="2" align="center" :allow-negative="true" class="percentage"/>
                                           </td>
                                       </tr>
                                       <tr>
                                           <td class="text-center">Тузатилган сумма</td>
                                           <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                               {{analog.calculated.termsOfSales | currency('', 2, { thousandsSeparator: ' ' })}}
                                           </td>
                                       </tr> -->

                                      <!--AFTER SALES-->
                                      <tr class="section-start">
                                          <td>Ижарадан кейинги харажатлар учун</td>
                                          <td>
                                              <select class="form-control" v-model="comparison.afterSale">
                                                  <option :value="option.code"
                                                          v-for="option in ref.afterSales" :key="option.code">
                                                      {{option.label}}
                                                  </option>
                                              </select>
                                          </td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <select class="form-control" v-model="analog.afterSale">
                                                  <option :value="option.code"
                                                          v-for="option in ref.afterSales" :key="option.code">
                                                      {{option.label}}
                                                  </option>
                                              </select>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td><i>Тузатишлар</i></td>
                                          <td class="text-center">%</td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <div class="percentage">
                                                  <select class="form-control" v-model="analog.fix.afterSales">
                                                      <option :value="option" v-for="option in analog.afterSalesOprions" :key="option">{{option}}</option>
                                                  </select>
                                                  <!--<numeric-input v-model="analog.fix.afterSales" :precision="2" align="center" :allow-negative="true" readonly/>-->
                                                  <span>%</span>
                                              </div>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{analog.calculated.afterSales | currency('', 2, { thousandsSeparator: ' '})}}
                                          </td>
                                      </tr>
                                      <!--<tr>-->
                                      <!--<td rowspan="2" class="font-weight-bold">-->
                                      <!--Ижарадан кейинги харажатлар учун-->
                                      <!--</td>-->
                                      <!--<td class="text-center">Тузатиш фоизи</td>-->
                                      <!--<td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">-->
                                      <!--<numeric-input v-model="analog.fix.afterSales" :precision="2" align="center" :allow-negative="true" class="percentage"/>-->
                                      <!--</td>-->
                                      <!--</tr>-->
                                      <!--<tr>-->
                                      <!--<td class="text-center">Тузатилган сумма</td>-->
                                      <!--<td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">-->
                                      <!--{{analog.calculated.afterSales | currency('', 2, { thousandsSeparator: ' ' })}}-->
                                      <!--</td>-->
                                      <!--</tr>-->

                                      <!--MARKET CONDITION-->
                                      <!--  <tr>
                                            <td rowspan="2" class="font-weight-bold">
                                                Бозор шартлари
                                            </td>
                                            <td class="text-center">Тузатиш фоизи</td>
                                            <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                <numeric-input v-model="analog.fix.marketCondition" :precision="2" align="center" :allow-negative="true" class="percentage"/>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-center">Тузатилган сумма</td>
                                            <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                {{analog.calculated.marketCondition | currency('', 2, { thousandsSeparator: ' ' })}}
                                            </td>
                                        </tr> -->

                                      <!--LOCATION-->
                                      <!--  <tr>
                                            <td rowspan="2" class="font-weight-bold">
                                                Жойлашган ери учун
                                            </td>
                                            <td class="text-center">Тузатиш фоизи</td>
                                            <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                <numeric-input v-model="analog.fix.location" :precision="2" align="center" :allow-negative="true" class="percentage"/>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-center">Тузатилган сумма</td>
                                            <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                {{analog.calculated.location | currency('', 2, { thousandsSeparator: ' ' })}}
                                            </td>
                                        </tr> -->

                                      <!--PHYSICAL CHARACTERISTICS-->
                                      <tr class="section-start">
                                          <td>Конструктив элемент ва коммуникациялар</td>
                                          <td>
                                              <select class="form-control" v-model="comparison.physicalCharacteristics">
                                                  <option :value="option.code"
                                                          v-for="option in ref.physicalCharacteristics" :key="option.code">
                                                      {{option.label}}
                                                  </option>
                                              </select>
                                          </td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <select class="form-control" v-model="analog.physicalCharacteristics">
                                                  <option :value="option.code"
                                                          v-for="option in ref.physicalCharacteristics" :key="option.code">
                                                      {{option.label}}
                                                  </option>
                                              </select>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td><i>Тузатишлар</i></td>
                                          <td class="text-center">%</td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <div class="percentage">
                                                  <numeric-input v-model="analog.fix.physicalCharacteristics" :precision="2" align="center" :allow-negative="true" class="percentage" readonly/>
                                                  <span>%</span>
                                              </div>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{analog.calculated.physicalCharacteristics | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <!--<tr>-->
                                      <!--<td rowspan="2" class="font-weight-bold">-->
                                      <!--Конструктив элемент ва коммуникациялар-->
                                      <!--</td>-->
                                      <!--<td class="text-center">Тузатиш фоизи</td>-->
                                      <!--<td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">-->
                                      <!--<numeric-input v-model="analog.fix.physicalCharacteristics" :precision="2" align="center" :allow-negative="true" class="percentage"/>-->
                                      <!--</td>-->
                                      <!--</tr>-->
                                      <!--<tr>-->
                                      <!--<td class="text-center">Тузатилган сумма</td>-->
                                      <!--<td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">-->
                                      <!--{{analog.calculated.physicalCharacteristics | currency('', 2, { thousandsSeparator: ' ' })}}-->
                                      <!--</td>-->
                                      <!--</tr>-->

                                      <!--ECONOMIC CHARACTERISTICS-->
                                      <tr class="section-start">
                                          <td>Иктисодий тавсифлари учун (Объект инфраструктураси)</td>
                                          <td>
                                              <select class="form-control" v-model="comparison.economicCharacteristics">
                                                  <option :value="option.code"
                                                          v-for="option in ref.economicCharacteristics" :key="option.code">
                                                      {{option.label}}
                                                  </option>
                                              </select>
                                          </td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <select class="form-control" v-model="analog.economicCharacteristics">
                                                  <option :value="option.code"
                                                          v-for="option in ref.economicCharacteristics" :key="option.code">
                                                      {{option.label}}
                                                  </option>
                                              </select>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td><i>Тузатишлар</i></td>
                                          <td class="text-center">%</td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <div class="percentage">
                                                  <numeric-input v-model="analog.fix.economicCharacteristics" :precision="2" align="center" :allow-negative="true" class="percentage" readonly/>
                                                  <span>%</span>
                                              </div>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{analog.calculated.economicCharacteristics | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <!--<tr>-->
                                      <!--<td rowspan="2" class="font-weight-bold">-->
                                      <!--Иктисодий тавсифлари учун (Объект инфраструктураси)-->
                                      <!--</td>-->
                                      <!--<td class="text-center">Тузатиш фоизи</td>-->
                                      <!--<td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">-->
                                      <!--<numeric-input v-model="analog.fix.economicCharacteristics" :precision="2" align="center" :allow-negative="true" class="percentage"/>-->
                                      <!--</td>-->
                                      <!--</tr>-->
                                      <!--<tr>-->
                                      <!--<td class="text-center">Тузатилган сумма</td>-->
                                      <!--<td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">-->
                                      <!--{{analog.calculated.economicCharacteristics | currency('', 2, { thousandsSeparator: ' ' })}}-->
                                      <!--</td>-->
                                      <!--</tr>-->

                                      <!--USAGE TYPE-->
                                      <!--  <tr>
                                            <td rowspan="2" class="font-weight-bold">
                                                Фойдаланиш тури учун (Ўзгартириш имконияти)
                                            </td>
                                            <td class="text-center">Тузатиш фоизи</td>
                                            <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                <numeric-input v-model="analog.fix.usageType" :precision="2" align="center" :allow-negative="true" class="percentage"/>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-center">Тузатилган сумма</td>
                                            <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                {{analog.calculated.usageType | currency('', 2, { thousandsSeparator: ' ' })}}
                                            </td>
                                        </tr> -->


                                      <!--CALCULATED PARAMETERS START-->
                                      <tr class="section-start">
                                          <td>Тугриланган киймат</td>
                                          <td class="text-center">Сум</td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{analog.calculated.usageType | currency('', 2, { thousandsSeparator: ' '})}}
                                          </td>
                                      </tr>
                                      <tr class="section-start">
                                          <td>Жами тузатишлар</td>
                                          <td class="text-center">Сони</td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{analog.fixedItemsCount}}
                                          </td>
                                      </tr>
                                      <tr class="section-start">
                                          <td>Танланган салмок</td>
                                          <td class="text-center">Фоиз</td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{analog.fixedItemsSharePercent | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr class="section-start">
                                          <td>Салмоклар микдори</td>
                                          <td class="text-center">Сум</td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{analog.fixedItemsShareAmount | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr class="section-start bold-row">
                                          <td>Тузатилган 1 кв.мга 1 йиллик тулов микдори</td>
                                          <td class="text-center">Сум</td>
                                          <td :colspan="comparison.analogs.length" class="text-center">
                                              {{calculated.rentPricePerM2PerYear | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <!--CALCULATED PARAMETERS END-->
                                  </table>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-12 btns-box">
                                <button class="all-btn delete-btn pull-left" @click="cancel" :disabled="processing">
                                    <i class="fa fa-close"></i>
                                    <span>{{$t("action.cancel")}}</span>
                                </button>
                                <button class="all-btn pull-right" @click="save(true)" :disabled="processing">
                                  <i class="fa fa-forward"></i>
                                  <span>Даромад ёндашув</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body" v-if="comparison.wizardSection===2">
                        <div class="row">
                            <div class="col-12 table-responsive">
                                <div class="table-wrapper">
                                  <table class="table table-striped comparison-table mb-0" style="min-width: 900px">
                                      <tr>
                                          <th colspan="3" class="text-center">Объектнинг даромад усулида бахолаш кийматини хисоб - китоби</th>
                                      </tr>
                                      <tr class="section-start">
                                          <td colspan="3" class="text-center">Бахоланаётган обеъкт</td>
                                      </tr>
                                      <tr>
                                          <td width="76%">Кадастр ёки баланс қиймати</td>
                                          <td width="13%">
                                              <numeric-input
                                                      v-model="comparison2.cadastreBalance" :precision="2" align="right"
                                                      :class="{invalid: $v.comparison2.cadastreBalance.$error}"
                                              />
                                              <div class="red" v-if="$v.comparison2.cadastreBalance.$error">{{$t("building.validation.cadastreBalance")}}</div>
                                          </td>
                                          <td width="11%">сум</td>
                                      </tr>
                                      <tr>
                                          <td>Колдик киймат</td>
                                          <td class="text-right">{{calculated2.cadastreBalance | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td>сум</td>
                                      </tr>
                                      <tr>
                                          <td>Мулк солиги</td>
                                          <td class="text-right">{{calculated2.propertyTaxAmount | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td>сум</td>
                                      </tr>
                                  </table>
                                </div>
                                <div class="table-wrapper">
                                  <table class="table table-striped comparison-table mb-0 no-border-top" style="min-width: 900px">
                                      <tr class="section-start">
                                          <td colspan="6" class="text-center">Даромадлар таҳлили</td>
                                      </tr>
                                      <tr class="bold-row">
                                          <td width="43%">Бино тури</td>
                                          <td width="11%" class="text-center">Бино ташки курилиш майдони</td>
                                          <td width="11%" class="text-center">1м2 бериладиган ижара суммаси 1-йилга</td>
                                          <td width="11%" class="text-center">Ялпи даромад</td>
                                          <td width="13%" class="text-center">Юклаш Коэффициенти</td>
                                          <td width="11%" class="text-center">Хакикий даромад</td>
                                      </tr>
                                      <tr>
                                          <td>Бино ва иншоотлар</td>
                                          <td class="text-right">
                                              {{calculated2.rentArea | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                          <td class="text-right">{{calculated2.rentPricePerM2PerYear | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td class="text-right">{{calculated2.grossIncome | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td>
                                              <select class="form-control" v-model="comparison2.coefficient.incomeLoad">
                                                  <option class="text-right" value="0.8">0.8</option>
                                                  <option class="text-right" value="0.85">0.85</option>
                                                  <option class="text-right" value="0.9">0.9</option>
                                                  <option class="text-right" value="0.95">0.95</option>
                                                  <option class="text-right" value="1">1</option>
                                              </select>
                                          </td>
                                          <td class="text-right">
                                              {{calculated2.realIncome | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Йиллик даромад</td>
                                          <td></td>
                                          <td class="text-right">{{calculated2.rentPricePerM2PerYear | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td class="text-right">{{calculated2.grossIncome | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td class="text-right">{{calculated2.coefficient.incomeLoad | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td class="text-right">{{calculated2.realIncome | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                      </tr>
                                  </table>
                                </div>

                                <div class="table-wrapper">
                                  <table class="table table-striped comparison-table mb-0 no-border-top" style="min-width: 900px">
                                      <tr class="section-start">
                                          <td colspan="4" class="text-center">Харажатлар таҳлили</td>
                                      </tr>
                                      <tr>
                                          <td width="65%">Мулк солиги</td>
                                          <td width="11%" class="text-right">2.0%</td>
                                          <td width="13%" class="text-right">{{calculated2.propertyTaxAmount | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td width="11%">сум</td>
                                      </tr>
                                      <tr>
                                          <td>Ер солиғи</td>
                                          <td class="text-right"></td>
                                          <td class="text-right">{{calculated2.landTaxAmount | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td>сум</td>
                                      </tr>
                                      <tr>
                                          <td>Жорий таъмирлаш</td>
                                          <td class="text-right">1%</td>
                                          <td class="text-right">{{calculated2.currentRepair | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td>сум</td>
                                      </tr>
                                      <tr>
                                          <td>Капитал жамгарма</td>
                                          <td class="text-right">18%</td>
                                          <td class="text-right">{{calculated2.capitalStock | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td>сум</td>
                                      </tr>
                                      <tr>
                                          <td>Капитал таъмирлаш учун йиллик ажратмалар</td>
                                          <td class="text-right">6%</td>
                                          <td class="text-right">{{calculated2.annualRepairs | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td>сум</td>
                                      </tr>
                                      <tr>
                                          <td>Келтириш коэффициент 6% бўлганда</td>
                                          <td class="text-right"></td>
                                          <td class="text-right">0.0429628</td>
                                          <td></td>
                                      </tr>
                                      <tr>
                                          <td>Сугурта</td>
                                          <td class="text-right">0.5%</td>
                                          <td class="text-right">{{calculated2.insurance | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td>сум</td>
                                      </tr>
                                      <tr>
                                          <td>Бошка харажатлар</td>
                                          <td class="text-right">2%</td>
                                          <td class="text-right">{{calculated2.expenseOthers | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td>сум</td>
                                      </tr>
                                      <tr>
                                          <td>Жами харажатлар</td>
                                          <td class="text-right"></td>
                                          <td class="text-right">{{calculated2.expenseTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td>сум</td>
                                      </tr>

                                      <tr class="section-start">
                                          <td colspan="4" class="text-center">Обект қийматини капиталлаштириш ставкасида ҳисоб-китоб қилиш</td>
                                      </tr>
                                      <tr>
                                          <td>Соф даромад</td>
                                          <td class="text-right"></td>
                                          <td class="text-right">{{calculated2.netIncome | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td>сум</td>
                                      </tr>
                                      <tr>
                                          <td>Даромад солиги (4%)</td>
                                          <td class="text-right"></td>
                                          <td class="text-right">{{calculated2.incomeTaxAmount | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td>сум</td>
                                      </tr>
                                      <tr>
                                          <td>Жами</td>
                                          <td class="text-right"></td>
                                          <td class="text-right">{{calculated2.totalAfterIncomeTax | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td>сум</td>
                                      </tr>
                                      <tr class="bold-row">
                                          <td>Обект қиймати 15%ли капиталлаштириш ставкасида</td>
                                          <td class="text-right"></td>
                                          <td class="text-right">{{calculated2.totalCapitalization | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td>сум</td>
                                      </tr>

                                      <tr class="section-start">
                                          <td colspan="4" class="text-center">Даромадда қатнашмайдиган иншоатлар</td>
                                      </tr>
                                      <tr v-for="(building, index) in comparison2.buildingsAttached" :key="building.id">
                                          <td>
                                              <v-select v-model="building.building" label="name"
                                                        :options="ref.buildingsToAttach"
                                                        :filterable="false"
                                                        @search="onBuildingToAttachSearch"
                                                        @search:focus="onBuildingToAttachFocus">
                                                  <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                              </v-select>
                                          </td>
                                          <td class="text-center">
                                              <template v-if="comparison2.buildingsAttached.length > 1">
                                                  <i class="fa fa-remove p-2"
                                                     style="color: red;cursor: pointer;display: inline-block;width: auto"
                                                     @click="removeBuildingAttached(index)">
                                                  </i>
                                              </template>
                                          </td>
                                          <td class="text-right">
                                              <template v-if="building.building && building.building.expensePrice && building.building.expensePrice > 0">
                                                  {{building.building.expensePrice | currency('', 2, { thousandsSeparator: ' ' })}}
                                              </template>
                                          </td>
                                          <td style="vertical-align: top">
                                              сум
                                              <button class="all-btn icon-btn pull-right" @click="addBuildingToAttach" v-if="index===0">
                                                  +
                                              </button>
                                          </td>
                                      </tr>

                                      <tr class="bold-row">
                                          <td>Жами:</td>
                                          <td class="text-right"></td>
                                          <td class="text-right">{{calculated2.total | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          <td>сум</td>
                                      </tr>
                                  </table>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-12 btns-box">
                                <button class="all-btn pull-left" @click="prevSection" :disabled="processing"><i class="fa fa-backward"></i><span>Олдинга</span></button>
                                <!--<button class="all-btn delete-btn ml-3" @click="cancel" :disabled="processing">-->
                                <!--<i class="fa fa-close"></i> {{$t("action.cancel")}}-->
                                <!--</button>-->
                                <button class="all-btn add-btn pull-right" @click="save(false)" :disabled="processing">
                                    <i class="fa fa-save"></i>
                                    <span>{{$t("action.save")}}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import Treeselect from '@riophae/vue-treeselect';
    import {formatDate, parseDate} from '@/shared/utils';
    import initFilterModel from '@/shared/filter';
    import {required, requiredUnless, minValue, minLength, maxLength} from 'vuelidate/lib/validators';
    import {calculateAnalogFixed} from '../../shared/calcApproachesAnalogFixes'
    import COMPARISON_REFERENCES from '@/shared/constants/realEstateComparison'

    export default {
        name: "RealEstateBuildingComparisonIncomeView",
        components: {
            Datepicker,
            Treeselect
        },
        data() {
            return {
                processing: false,
                parentName: ((this.$route.params.hasOwnProperty('parentName') && this.$route.params.parentName) ? ('/' + this.$route.params.parentName + '/') : '/'),
                realEstateId: ((this.$route.params.hasOwnProperty('realEstateId') && this.$route.params.realEstateId) ? this.$route.params.realEstateId : null),
                buildingId: ((this.$route.params.hasOwnProperty('buildingId') && this.$route.params.buildingId) ? this.$route.params.buildingId : null),
                buildingsToAttachFilter: initFilterModel(),
                name: '',
                floors: 0,
                taxPerHectare: 0,
                comparisonExpenseCalculatedTotalPrice: 0,
                region: null,
                comparison: {
                    wizardSection: 1,
                    //first view
                    area: 0,
                    exchangeRate: null,
                    exchangeRateDate: null,
                    // advertisementDatePicked: new Date(),
                    closenessToCenter: null,
                    afterSale: 'exists',
                    physicalCharacteristics: 'high',
                    economicCharacteristics: 'high',
                    analogs: []
                },
                comparison2: {
                    cadastreBalance: 0,
                    coefficient: {
                        propertyTax: 2.0,
                        incomeLoad: 0.8,
                        currentRepair: 1.0,
                        capitalStock: 18.0,
                        annualRepairs: 6.0,
                        comingCoefficient6p: 0.0429628,
                        insurance: 0.5,
                        expenseOthers: 2.0,
                        incomeTax: 4.0,
                        capitalizePercent: 15.0
                    },
                    buildingsAttached: []
                },
                ref: {
                    provinces: [],
                    ...COMPARISON_REFERENCES,
                    buildingsToAttach: []
                },
                createDate: null,
                confirmedDate: null,
                model: {
                    disabledDates:{}
                }
            }
        },
        validations() {
            return {
                comparison: {
                    area: {
                        required: required,
                        minValue: minValue(0.01)
                    },
                    analogs: {
                        required: required,
                        minLength: minLength(3),
                        maxLength: maxLength(5),
                        $each: {
                            source: {
                                required: required
                            },
                            rentArea: {
                                required: required,
                                minValue: minValue(0.01)
                            },
                            rentPerMonth: {
                                required: required,
                                minValue: minValue(0.01)
                            }
                        }
                    }
                },
                comparison2: {
                    cadastreBalance: {
                        required: requiredUnless(() => {
                            return !(this.comparison.wizardSection === 2);
                        })
                    }
                }
            }
        },
        computed: {
            calculated() {
                let rentPricePerM2PerYear = 0;
                let fixedItemsCountTotal = 0;
                this.comparison.analogs.forEach((analog) => {

                    // fix
                    analog.fix.advertisementDatePicked = calculateAnalogFixed.calculateFixAdvertisementDatePicked(analog.createDate, analog.advertisementDatePicked);
                    analog.fix.physicalCharacteristics = calculateAnalogFixed.calculateFixPhysicalCharacteristics(this.comparison.physicalCharacteristics, analog.physicalCharacteristics);
                    analog.fix.economicCharacteristics = calculateAnalogFixed.calculateFixEconomicClassifications(this.comparison.economicCharacteristics, analog.economicCharacteristics);

                    analog.rentPerUnitUSD = (analog.rentArea && analog.rentArea > 0) ? ((analog.rentPerMonth / this.comparison.exchangeRate) / analog.rentArea) : null;
                    analog.rentPerUnit = analog.rentPerUnitUSD * this.comparison.exchangeRate;
                    analog.rentPerUnitYearly = analog.rentPerUnit * 12;

                    if (this.comparison.afterSale === 'exists' && analog.afterSale === 'non_exists') {
                        analog.afterSalesOprions = [-5, -10];
                        if (analog.fix.afterSales >= 0) {
                            analog.fix.afterSales = -5;
                        }
                    } else if (this.comparison.afterSale === 'non_exists' && analog.afterSale === 'exists') {
                        analog.afterSalesOprions = [5, 10];
                        if (analog.fix.afterSales <= 0) {
                            analog.fix.afterSales = 5;
                        }
                    } else {
                        analog.afterSalesOprions = [0];
                        analog.fix.afterSales = 0;
                    }

                    // analog.calculated.typeOfLaw = this.calculateFixed(analog.rentPerUnitYearly, analog.fix.typeOfLaw);
                    // analog.calculated.financialCondition = this.calculateFixed(analog.calculated.typeOfLaw, analog.fix.financialCondition);
                    // analog.calculated.termsOfSales = this.calculateFixed(analog.calculated.financialCondition, analog.fix.termsOfSales);
                    // analog.calculated.marketCondition = this.calculateFixed(analog.calculated.afterSales, analog.fix.marketCondition);
                    // analog.calculated.location = this.calculateFixed(analog.calculated.marketCondition, analog.fix.location);
                    // analog.calculated.usageType = this.calculateFixed(analog.calculated.economicCharacteristics, analog.fix.usageType);
                    analog.calculated.advertisementDatePicked = this.calculateFixed(analog.rentPerUnitYearly, analog.fix.advertisementDatePicked);
                    analog.calculated.afterSales = this.calculateFixed(analog.calculated.advertisementDatePicked, analog.fix.afterSales);
                    analog.calculated.physicalCharacteristics = this.calculateFixed(analog.calculated.afterSales, analog.fix.physicalCharacteristics);
                    analog.calculated.economicCharacteristics = this.calculateFixed(analog.calculated.physicalCharacteristics, analog.fix.economicCharacteristics);
                    analog.calculated.usageType = this.calculateFixed(analog.calculated.economicCharacteristics, analog.fix.usageType);

                    let fixedItemsCount = 0;
                    Object.keys(analog.fix).forEach((key) => {
                        if (analog.fix[key] && analog.fix[key] !== 0) {
                            fixedItemsCount++;
                        }
                    });
                    analog.fixedItemsCount = fixedItemsCount;
                    if (analog.fixedItemsCount && analog.fixedItemsCount > 0) {
                        fixedItemsCountTotal += analog.fixedItemsCount;
                    }
                });

                this.comparison.analogs.forEach((analog) => {
                    if (fixedItemsCountTotal && fixedItemsCountTotal > 0) {
                        analog.fixedItemsSharePercent = (analog.fixedItemsCount && analog.fixedItemsCount > 0) ? (analog.fixedItemsCount * 100 / fixedItemsCountTotal) : null;
                        analog.fixedItemsShareAmount = (analog.fixedItemsSharePercent && analog.fixedItemsSharePercent > 0) ? (analog.calculated.usageType * analog.fixedItemsSharePercent) / 100 : null;
                    } else {
                        analog.fixedItemsSharePercent = null;
                        analog.fixedItemsShareAmount = analog.calculated.usageType;
                    }
                    // if (analog.fixedItemsShareAmount && analog.fixedItemsShareAmount > 0) {
                    //     rentPricePerM2PerYear += analog.fixedItemsShareAmount;
                    // }
                    rentPricePerM2PerYear +=  analog.calculated.usageType;
                });
                return {
                    analogs: this.comparison.analogs,
                    rentArea: (this.comparison.area ? this.comparison.area : 0)/* * (this.floors ? this.floors : 0)*/,
                    rentPricePerM2PerYear: rentPricePerM2PerYear / 3
                }
            },
            calculated2() {
                const propertyTaxAmount = (this.comparison2.cadastreBalance * this.comparison2.coefficient.propertyTax) / 100;
                const rentArea = this.calculated.rentArea;

                const rentPricePerM2PerYear = this.calculated.rentPricePerM2PerYear;
                const grossIncome = rentArea * rentPricePerM2PerYear;
                const realIncome = grossIncome * this.comparison2.coefficient.incomeLoad;

                const areaInHectare = this.comparison.area * 0.0001;
                let landTaxAmount = 0;
                if (this.taxPerHectare) {
                    landTaxAmount = this.taxPerHectare * areaInHectare;
                }
                const currentRepair = (this.comparison2.coefficient.currentRepair * realIncome) / 100;
                const capitalStock = (this.comparison2.coefficient.capitalStock * realIncome) / 100;
                const annualRepairs = capitalStock * this.comparison2.coefficient.comingCoefficient6p;
                const insurance = (this.comparison2.coefficient.insurance * this.comparisonExpenseCalculatedTotalPrice) / 100;
                const expenseOthers = (this.comparison2.coefficient.expenseOthers * realIncome) / 100;
                const expenseTotal = ((propertyTaxAmount ? propertyTaxAmount : 0)
                    + (landTaxAmount ? landTaxAmount : 0)
                    + (currentRepair ? currentRepair : 0)
                    + (annualRepairs ? annualRepairs : 0)
                    + (insurance ? insurance : 0)
                    + (expenseOthers ? expenseOthers : 0));

                const netIncome = (realIncome - expenseTotal);
                const incomeTaxAmount = (netIncome * this.comparison2.coefficient.incomeTax) / 100;
                const totalAfterIncomeTax = (netIncome - incomeTaxAmount);
                const totalCapitalization = totalAfterIncomeTax / (this.comparison2.coefficient.capitalizePercent / 100);

                let totalBuildingsAttached = 0;
                this.comparison2.buildingsAttached.forEach((item) => {
                    if (item.building && item.building.expensePrice && item.building.expensePrice > 0) {
                        totalBuildingsAttached += item.building.expensePrice;
                    }
                });

                const total = totalCapitalization + totalBuildingsAttached;

                return {
                    cadastreBalance: this.comparison2.cadastreBalance,
                    area: this.comparison.area,
                    floors: this.floors,
                    rentArea: rentArea,
                    areaInHectare: areaInHectare,

                    rentPricePerM2PerYear: rentPricePerM2PerYear,
                    grossIncome: grossIncome,
                    realIncome: realIncome,

                    taxPerHectare: this.taxPerHectare,
                    propertyTaxAmount: propertyTaxAmount,
                    landTaxAmount: landTaxAmount,
                    currentRepair: currentRepair,
                    capitalStock: capitalStock,
                    annualRepairs: annualRepairs,
                    insurance: insurance,
                    expenseOthers: expenseOthers,
                    expenseTotal: expenseTotal,

                    netIncome: netIncome,
                    incomeTaxAmount: incomeTaxAmount,
                    totalAfterIncomeTax: totalAfterIncomeTax,
                    totalCapitalization: totalCapitalization,
                    totalBuildingsAttached: totalBuildingsAttached,
                    total: total,

                    coefficient: this.comparison2.coefficient
                }
            }
        },
        methods: {
            init() {
                const vm = this;
                this.$http.get('real-estate/building/comparison-income/' + this.buildingId)
                    .then(res => {
                        // header
                        vm.createDate = res.data.createDate;
                        vm.name = res.data.name;
                        vm.floors = res.data.floors;
                        vm.region = res.data.region;
                        vm.ref.provinces = res.data.provinces;
                        // vm.areaRealEstate = res.data.areaRealEstate;
                        vm.taxPerHectare = res.data.taxPerHectare;
                        vm.comparisonExpenseCalculatedTotalPrice = res.data.comparisonExpenseCalculatedTotalPrice;
                        // comparisons
                        let comparison = res.data.comparison;
                        if (!comparison) {
                            comparison = {};
                        }
                        if (!comparison.analogs) {
                            comparison.analogs = [];
                        }
                        // if (comparison.advertisementDate) {
                        //     comparison.advertisementDatePicked = parseDate(comparison.advertisementDate);
                        // }
                        if (comparison.analogs && comparison.analogs.length > 0) {
                            comparison.analogs.forEach((analog) => {
                                analog.advertisementDatePicked = parseDate(analog.advertisementDate);
                                analog.createDate = vm.createDate;
                            });
                        }
                        if (!comparison.area) {
                            comparison.area = res.data.area;
                        }
                        vm.comparison = comparison;
                        if (comparison.calculated && comparison.calculated.cadastreBalance) {
                            vm.comparison2.cadastreBalance = comparison.calculated.cadastreBalance;
                        }
                        if (comparison.coefficient) {
                            vm.comparison2.coefficient = comparison.coefficient;
                        }
                        if (comparison.buildingsAttached && comparison.buildingsAttached.length > 0) {
                            vm.comparison2.buildingsAttached = comparison.buildingsAttached.map((item) => {
                                return {
                                    building: item
                                }
                            });
                        } else {
                            this.addBuildingToAttach();
                        }
                        while (vm.comparison.analogs.length < 3) {
                            this.addAnalog();
                        }
                        if (res.data && res.data.confirmedDate)  {
                            vm.confirmedDate = res.data.confirmedDate;
                            vm.model.disabledDates['from'] = parseDate(vm.confirmedDate);
                        }
                    }, err => {
                        console.log(err);
                    });
            },
            cancel() {
                this.$router.push(this.parentName + 'real-estate/edit/' + this.realEstateId);
            },
            save(next) {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.processing = true;
                // this.comparison.advertisementDate = formatDate(this.comparison.advertisementDatePicked);
                this.comparison.analogs.forEach((analog) => {
                    analog.advertisementDate = formatDate(analog.advertisementDatePicked);
                });
                const buildingsAttached = [];
                this.comparison2.buildingsAttached.map((item) => {
                    if (item.building) {
                        buildingsAttached.push({
                            id: item.building.id,
                            expensePrice: item.building.expensePrice
                        });
                    }
                });
                this.comparison.buildingsAttached = buildingsAttached;
                this.comparison.coefficient = this.calculated2.coefficient;
                this.comparison.calculated = this.calculated2;
                if (next) {
                    this.comparison.wizardSection = 2;
                }
                this.$http.post('real-estate/building/comparison-income/' + this.buildingId, this.comparison)
                    .then(res => {
                        console.log(res.data);
                        if (!next) {
                            this.$router.push(this.parentName + 'real-estate/edit/' + this.realEstateId);
                        }
                        this.processing = false;
                    }, err => {
                        this.processing = false;
                        console.log(err);
                    });
            },
            prevSection() {
                this.comparison.wizardSection = 1;
            },
            addAnalog() {
                if (this.comparison.analogs.length < 4) {
                    this.comparison.analogs.push({
                        source: '',
                        region: null,
                        rentArea: 0,
                        rentPerMonth: 0,
                        rentPerUnitUSD: 0,
                        rentPerUnit: 0,
                        rentPerUnitYearly: 0,
                        advertisementDatePicked: new Date(),
                        closenessToCenter: '',
                        afterSale: 'exists',
                        physicalCharacteristics: 'high',
                        economicCharacteristics: 'high',
                        fix: {
                            advertisementDatePicked: 0,
                            typeOfLaw: 0,
                            financialCondition: 0,
                            termsOfSales: 0,
                            afterSales: 0,
                            marketCondition: 0,
                            location: 0,
                            physicalCharacteristics: 0,
                            economicCharacteristics: 0,
                            usageType: 0
                        },
                        calculated: {
                            advertisementDatePicked: null,
                            typeOfLaw: null,
                            financialCondition: null,
                            termsOfSales: null,
                            afterSales: null,
                            marketCondition: null,
                            location: null,
                            physicalCharacteristics: null,
                            economicCharacteristics: null,
                            usageType: null,
                            total: null
                        },
                        fixedItemsCount: 0,
                        fixedItemsSharePercent: 0,
                        fixedItemsShareAmount: 0,
                        createDate: this.createDate
                    });
                }
            },
            removeAnalog(index) {
                this.comparison.analogs.splice(index, 1);
            },
            calculateFixed(value, fixPercentage) {
                if (value && fixPercentage && fixPercentage !== 0) {
                    return value + value * (fixPercentage / 100);
                } else {
                    return value;
                }
            },
            addBuildingToAttach() {
                this.comparison2.buildingsAttached.push({
                    building: null
                });
            },
            removeBuildingAttached(index) {
                this.comparison2.buildingsAttached.splice(index, 1);
            },
            onBuildingToAttachSearch(searchTxt, loading) {
                loading(true);
                this.ref.buildingsToAttach = [];
                this.buildingsToAttachFilter.search = searchTxt;
                if (this.buildingId && this.buildingId > 0) {
                    this.buildingsToAttachFilter.excluded = [this.buildingId];
                }
                this.$http.post('real-estate/' + this.realEstateId + '/building/search', this.buildingsToAttachFilter)
                    .then(res => {
                        this.ref.buildingsToAttach = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onBuildingToAttachFocus() {
                this.ref.buildingsToAttach = [];
                this.buildingsToAttachFilter.search = '';
                if (this.buildingId && this.buildingId > 0) {
                    this.buildingsToAttachFilter.excluded = [this.buildingId];
                }
                this.$http.post('real-estate/' + this.realEstateId + '/building/search', this.buildingsToAttachFilter)
                    .then(res => {
                        this.ref.buildingsToAttach = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            }
        },
        created() {
            this.init();
        }
    }
</script>

<style scoped>
    .comparison-table th {
        /*vertical-align: top;*/
        border: 1px solid #dee2e6;
        border-collapse: collapse;
        background-color: #E9FAFD;
    }

    .comparison-table td {
        border: 1px solid #dee2e6;
        border-collapse: collapse;
    }

    .comparison-table .percentage {
        margin: auto;
        width: 110px !important;
        display: inline-block;
    }

    .comparison-table .percentage div {
        width: 80px !important;
        float: left;
    }

    .comparison-table .percentage span {
        display: block;
        margin: 7px 5px;
        float: left;
    }

    .comparison-table .section-start td {
        background-color: #F3F3F3;
    }

    .comparison-table .section-start > td:first-child {
        font-weight: bold;
    }

    .no-border-top .section-start td {
        border-top: 0 !important;
    }
</style>
